module.exports = __webpack_public_path__ + "static/media/cover-marroco.1be2306a.png";